import React, { useState, useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList, } from "recharts";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Modal from "react-modal";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Close from "../../../../images/icons/close.svg";
import profile_image from "../../../../images/user/Default_pfp.png";
import { calculateCategoryExpenses } from "./Services/reportExpense";

const data = [
  { name: "Rent", currentYear: 44, lastYear: 24 },
  { name: "Utilities", currentYear: 55, lastYear: 39 },
  { name: "Groceries", currentYear: 13, lastYear: 30 },
  { name: "Transport", currentYear: 43, lastYear: 50 },
  { name: "Entertainment", currentYear: 46, lastYear: 27 },
  { name: "Healthcare", currentYear: 55, lastYear: 40 },
  { name: "Miscellaneous", currentYear: 32, lastYear: 18 },
];

// const calculateXTicks = (data) => {
//   if (data.length === 0) return [];

//   const maxDataValue = Math.max(...data.map(item => Math.max(item.currentYear, item.lastYear)));
//   // const tickInterval = 10;
//   const tickInterval = Math.ceil(maxDataValue / 10); // Set the interval between ticks
//   const numOfTicks = Math.ceil(maxDataValue / tickInterval);
//   const ticks = [];

//   // for (let i = 0; i <= numOfTicks + 4; i++) { // Adjust the number of ticks
//   //   ticks.push(i * tickInterval);
//   // }
//   for (let i = 0; i <= numOfTicks + 4; i += tickInterval) {
//     ticks.push(i);
//   }
//   return ticks;
// };

const ExpenseHistory = ({
  expenseData,
  expenseDataLoading,
  expenseDataError,
}) => {
  const reportingFinancialExpense = useSelector(
    (state) => state.reportingExpense
  );
  const { forex } = useSelector((state) => state.forex);
  const settings = JSON.parse(localStorage.getItem("settings"));
  const componentRef = useRef(null);

  const currentYear =
    reportingFinancialExpense.expYear || new Date().getFullYear();
  const previousYear = currentYear - 1;
  const isCurrentYear = currentYear === new Date().getFullYear();

  const setReportingCurrency = useSelector(
    (state) => state.reportingExpense.expCurrency
  );
  var currencies = "USD";
  if (setReportingCurrency && setReportingCurrency.length === 1) {
    currencies = setReportingCurrency[0];
  } else {
    currencies = settings.currency;
  }

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const currentYearExpenses = useMemo(
    () =>
      calculateCategoryExpenses(
        expenseData,
        reportingFinancialExpense,
        currencies,
        forex,
        currentYear
      ),
    [expenseData, reportingFinancialExpense, currencies, forex, currentYear]
  );
  const lastYearExpenses = useMemo(
    () =>
      calculateCategoryExpenses(
        expenseData,
        reportingFinancialExpense,
        currencies,
        forex,
        previousYear
      ),
    [expenseData, reportingFinancialExpense, currencies, forex, previousYear]
  );

  const processedData = Object.keys(currentYearExpenses).map((category) => ({
    name: category,
    currentYear: parseFloat(currentYearExpenses[category].toFixed(2)) || 0,
    lastYear: parseFloat(lastYearExpenses[category].toFixed(2)) || 0,
  }));

  const handleBarCurrentYearClick = (data) => {
    setSelectedYear(currentYear);
    setSelectedCategory(data.name);
    setShowModal(true);
  };

  const handleBarLastYearClick = (data) => {
    setSelectedYear(previousYear);
    setSelectedCategory(data.name);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const filteredExpenses = expenseData
    .filter(
      (expense) =>
        expense.exp_category &&
        expense.exp_category.exp_category_name === selectedCategory &&
        !expense.is_delete &&
        selectedYear &&
        new Date(expense.exp_date).getFullYear() === selectedYear &&
        reportingFinancialExpense.expCurrency &&
        reportingFinancialExpense.expCurrency.includes(expense.exp_currency)
    )
    .map((expense) => ({
      exp_id: expense.exp_id,
      exp_category_name: expense.exp_category.exp_category_name,
      client_name: expense.exp_client
        ? expense.exp_client.client_name || expense.exp_client.legal_entity_name
        : "Non Billable",
      exp_user: expense.exp_user,
      exp_date: expense.exp_date,
      exp_is_billable: expense.exp_is_billable ? "Yes" : "No",
      amount: expense.exp_amount,
      currency: expense.exp_currency,
      created_at: expense.created_at,
    }));

  const useRenderExpenseUser = (rowData) => {
    const [showFullname, setShowFullname] = useState(false);

    const fullName = rowData.exp_user?.first_name
      ? `${rowData.exp_user.first_name} ${rowData.exp_user.middle_name && rowData.exp_user.middle_name !== "null"
        ? rowData.exp_user.middle_name + " "
        : ""
      }${rowData.exp_user.last_name}`
      : rowData.exp_user?.company_first_name
        ? `${rowData.exp_user.company_first_name} ${rowData.exp_user.company_last_name ? rowData.exp_user.company_last_name : ""
        }`
        : rowData.exp_user?.company_name;
    const displayName = showFullname
      ? fullName
      : fullName.length <= 15
        ? fullName
        : fullName.slice(0, 15) + "...";

    return (
      <div
        className={`member-name${showFullname ? " active" : ""}`}
        // onMouseEnter={() => setShowFullname(true)}
        onMouseEnter={() => {
          if (fullName.length > 15) {
            setShowFullname(true);
          }
        }}
        onMouseLeave={() => setShowFullname(false)}
      >
        {rowData.exp_user?.profile_image !== null &&
          rowData.exp_user?.profile_image !== "null" ? (
          <img
            src={`/uploads/lowProfileImage/${rowData.exp_user?.profile_image}`}
            alt={fullName}
            className="member-image"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/uploads/lowProfileImage/user_default.png";
            }}
          />
        ) : (
          <img src={profile_image} alt={fullName} className="member-image" />
        )}
        <span>{displayName}</span>
      </div>
    );
  };

  const renderStatus = (rowData) => {
    const status = rowData.exp_is_billable;
    const statusClass =
      status === "Yes" ? "payment-status manual" : "payment-status overdue";
    return <span className={`payment-status ${statusClass}`}>{status}</span>;
  };

  const renderDueDate = (rowData) => {
    const dueDate = new Date(rowData.exp_date);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return dueDate.toLocaleDateString(undefined, options);
  };

  const renderAmount = (rowData) => {
    var totalAmount = rowData?.amount.toLocaleString("en-US", {
      style: "currency",
      currency: rowData.currency || "USD",
    });

    return `${totalAmount}`;
  };

  if (expenseDataLoading) {
    const skeletonRows = 8;
    const rowHeight = 50;
    const baseHeight = 100;
    const skeletonHeight = skeletonRows * rowHeight + baseHeight;
    
    // Fixed widths for skeleton bars to avoid random values
    const barWidths = [45, 60, 35, 55, 40, 50, 38, 48];
    
    return (
      <div className='graph-project-per-hour' style={{ width: '100%', height: Math.max(542, skeletonHeight) }}>
        <div style={{ 
          width: '100%', 
          height: '100%', 
          padding: '20px 42px 5px 30px',
          position: 'relative'
        }}>
          {/* Y-axis skeleton labels */}
          <div style={{ 
            position: 'absolute', 
            left: '0', 
            top: '20px', 
            bottom: '5px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            paddingRight: '10px'
          }}>
            {Array.from({ length: skeletonRows }).map((_, index) => (
              <div
                key={index}
                style={{
                  width: '120px',
                  height: '13px',
                  backgroundColor: '#e5e7eb',
                  borderRadius: '4px',
                  animation: 'pulse 1.5s ease-in-out infinite',
                }}
              />
            ))}
          </div>

          {/* Chart area with bars */}
          <div style={{ 
            marginLeft: '150px',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            paddingTop: '10px',
            paddingBottom: '30px'
          }}>
            {Array.from({ length: skeletonRows }).map((_, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  height: '50px',
                  position: 'relative'
                }}
              >
                {/* Current Year bar skeleton */}
                <div
                  style={{
                    width: `${barWidths[index] || 45}%`,
                    height: '13px',
                    backgroundColor: '#87ABE2',
                    opacity: 0.3,
                    borderRadius: '2px',
                    animation: 'pulse 1.5s ease-in-out infinite',
                  }}
                />
                {/* Last Year bar skeleton */}
                <div
                  style={{
                    width: `${(barWidths[index] || 45) - 10}%`,
                    height: '13px',
                    backgroundColor: '#C7B6F6',
                    opacity: 0.3,
                    borderRadius: '2px',
                    animation: 'pulse 1.5s ease-in-out infinite',
                    animationDelay: '0.2s'
                  }}
                />
              </div>
            ))}
          </div>

          {/* X-axis skeleton ticks */}
          <div style={{ 
            position: 'absolute', 
            bottom: '5px', 
            left: '150px', 
            right: '42px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end'
          }}>
            {Array.from({ length: 6 }).map((_, index) => (
              <div
                key={index}
                style={{
                  width: '40px',
                  height: '12px',
                  backgroundColor: '#e5e7eb',
                  borderRadius: '4px',
                  animation: 'pulse 1.5s ease-in-out infinite',
                }}
              />
            ))}
          </div>
        </div>
        <style>{`
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
          }
        `}</style>
      </div>
    );
  }
  if (expenseDataError) return <div>Error loading data.</div>;

  const calculateXTicks = () => {
    if (!processedData.length) return [];
    const maxDataValue = Math.max(
      ...processedData.map((item) => Math.max(item.currentYear, item.lastYear))
    );
    if (maxDataValue === 0) return [0];
    // const tickInterval = 10; // Set the interval between ticks
    const tickInterval = Math.ceil(maxDataValue / 10);
    const numOfTicks = Math.ceil(maxDataValue / tickInterval);
    const ticks = [];

    for (let i = 0; i <= numOfTicks + 4; i++) {
      // Adjust the number of ticks
      ticks.push(i * tickInterval);
    }

    return ticks;
  };
  // const xAxisTicks = calculateXTicks(processedData);
  const xAxisTicks = calculateXTicks();

  const calculateChartHeight = (dataLength) => {
    const rowHeight = 50; // Adjust this value to set the height per bar
    const baseHeight = 100; // Add some base height for padding and labels
    return dataLength * rowHeight + baseHeight;
  };

  const fadeIn = {
    hidden: { opacity: 0 , scale: 0.97},
    visible: { opacity: 1 , scale: 1},
  };

  const maxLabelLength = Math.max(...processedData.map((item) => item.name.length));
  const dynamicLeftMargin = Math.max(0, maxLabelLength);

  return (
    <div
      className="graph-project-per-hour"
      style={{
        width: "100%",
        height: Math.max(542, calculateChartHeight(processedData.length)),
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          layout="vertical"
          data={processedData}
          barSize={13} // Set the height of each bar
          margin={{
            top: 20,
            right: 42,
            left: dynamicLeftMargin, // Adjust the left margin to remove white space
            bottom: 5,
          }}
        // onClick={handleBarClick}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            horizontal={false}
            vertical={true}
          />
          <XAxis
            type="number"
            domain={[0, "dataMax + 10"]}
            tickFormatter={(tick) =>
              `${new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: currencies,
              })
                .format(0)
                .replace(/[\d.,]/g, "")}${tick}`
            }
            ticks={xAxisTicks}
          />
          <YAxis
            type="category"
            dataKey="name"
            // width={150} // Ensure enough width for expense categories
            tickMargin={10}
          />
          <Tooltip
            formatter={(value) =>
              `${new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: currencies,
              }).format(value)}`
            }
          />
          <Legend />
          <Bar
            dataKey="currentYear"
            name={
              isCurrentYear
                ? `Current Year (${currentYear})`
                : `Selected Year (${currentYear})`
            }
            onClick={handleBarCurrentYearClick}
            fill="#87ABE2"
          >
            <LabelList
              dataKey="currentYear"
              position="right"
              formatter={(value) =>
                `${new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: currencies,
                }).format(value)}`
              }
            />
          </Bar>
          <Bar
            dataKey="lastYear"
            name={
              isCurrentYear
                ? `Last Year (${previousYear})`
                : `Previous Year (${previousYear})`
            }
            onClick={handleBarLastYearClick}
            fill="#C7B6F6"
          >
            <LabelList
              dataKey="lastYear"
              position="right"
              formatter={(value) =>
                `${new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: currencies,
                }).format(value)}`
              }
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      <Modal
        isOpen={showModal}
        onRequestClose={handleCloseModal}
        ariaHideApp={false}
        className="client-modal sprint-modal add-bank-account-modal account-details-modal report-grpah-filter"
        contentLabel="Invite a User"
        style={{
          content: {
            height: "41%",
            width: "70%",
            position: "fixed",
            top: "50%",
            left: "50%",
            overflow: "hidden",
          },
        }}
      >
        <div className="modal add-bank-account-content account-details-modal-inner report-grpah-filter-inner">
          <div className="modal-close-invite outter-modal-main graph-name-outer">
            <div className="modal-invite-head">
              <h2 className=""> Report Details </h2>
            </div>
            <Link className="" onClick={handleCloseModal}>
              <img src={Close} alt="Edit Icon" />{" "}
            </Link>
          </div>
          <div className="graph-name-filter">
            Expenses History
          </div>

          <motion.div
            ref={componentRef}
            initial="hidden"
            animate="visible"
            variants={fadeIn}
            transition={{ duration: 2.2 }}
          >
            <div className="modal-body-filter">
              <DataTable
                value={filteredExpenses}
                sort
                className="recent-invoice-inner"
                tableStyle={{
                  minWidth: "50rem",
                  width: "100%",
                  textAlign: "left",
                }}
                paginator={false}
                paginatorClassName="recent-invoices-pagination"
                emptyMessage={
                  expenseDataLoading ? (
                    <div className="datatable-team-maintb">
                      <div className="p-datatable p-component p-datatable-responsive-scroll" style={{ marginBottom: 0, paddingBottom: 0 }}>
                        <div className="p-datatable-wrapper" style={{ paddingBottom: 0, marginBottom: 0 }}>
                          <table
                            className="p-datatable-table"
                            style={{ minWidth: "50rem", width: "100%", textAlign: "left", marginBottom: 0, borderSpacing: 0 }}
                          >
                            <thead className="p-datatable-thead">
                              <tr>
                                <th style={{ paddingRight: "20px", textAlign: "left", paddingLeft: "22px", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>Expense Id</th>
                                <th style={{ paddingRight: "20px", textAlign: "left", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>Category</th>
                                <th style={{ paddingRight: "20px", textAlign: "left", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>User</th>
                                <th style={{ paddingRight: "20px", textAlign: "left", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>Client</th>
                                <th style={{ paddingRight: "20px", textAlign: "left", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>Date</th>
                                <th style={{ paddingRight: "20px", textAlign: "left", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>Billable</th>
                                <th style={{ paddingRight: "20px", textAlign: "left", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>Amount</th>
                              </tr>
                            </thead>
                            <tbody className="p-datatable-tbody" style={{ marginBottom: 0, paddingBottom: 0 }}>
                              {Array.from({ length: 5 }).map((_, index) => (
                                <tr key={`skeleton-${index}`}>
                                  <td style={{ paddingRight: "20px", paddingLeft: "22px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                                    <div style={{ width: "80px", height: "20px", backgroundColor: "#e5e7eb", borderRadius: "4px", animation: "pulse 1.5s ease-in-out infinite" }} />
                                  </td>
                                  <td style={{ paddingRight: "20px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                                    <div style={{ width: "100px", height: "20px", backgroundColor: "#e5e7eb", borderRadius: "4px", animation: "pulse 1.5s ease-in-out infinite" }} />
                                  </td>
                                  <td style={{ paddingRight: "20px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                      <div style={{ width: "40px", height: "40px", borderRadius: "50%", backgroundColor: "#e5e7eb", animation: "pulse 1.5s ease-in-out infinite", flexShrink: 0 }} />
                                      <div style={{ width: "120px", height: "20px", backgroundColor: "#e5e7eb", borderRadius: "4px", animation: "pulse 1.5s ease-in-out infinite" }} />
                                    </div>
                                  </td>
                                  <td style={{ paddingRight: "20px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                                    <div style={{ width: "120px", height: "20px", backgroundColor: "#e5e7eb", borderRadius: "4px", animation: "pulse 1.5s ease-in-out infinite" }} />
                                  </td>
                                  <td style={{ paddingRight: "20px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                                    <div style={{ width: "140px", height: "20px", backgroundColor: "#e5e7eb", borderRadius: "4px", animation: "pulse 1.5s ease-in-out infinite" }} />
                                  </td>
                                  <td style={{ paddingRight: "20px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                                    <div style={{ width: "60px", height: "24px", backgroundColor: "#e5e7eb", borderRadius: "12px", animation: "pulse 1.5s ease-in-out infinite" }} />
                                  </td>
                                  <td style={{ paddingRight: "20px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                                    <div style={{ width: "80px", height: "20px", backgroundColor: "#e5e7eb", borderRadius: "4px", animation: "pulse 1.5s ease-in-out infinite" }} />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <style>{`
                        @keyframes pulse {
                          0%, 100% {
                            opacity: 1;
                          }
                          50% {
                            opacity: 0.5;
                          }
                        }
                      `}</style>
                    </div>
                  ) : (
                    "No results found"
                  )
                }
              >
                <Column
                  field="exp_id"
                  header="Expense Id"
                  sortable
                  style={{ paddingRight: "20px" }}
                ></Column>
                <Column
                  field="exp_category_name"
                  header="Category"
                  style={{ paddingRight: "20px" }}
                ></Column>
                <Column
                  field="exp_user"
                  body={useRenderExpenseUser}
                  header="User"
                  sortable
                  style={{  paddingRight: "20px" }}
                ></Column>
                <Column
                  field="client_name"
                  header="Client"
                  sortable
                  style={{ paddingRight: "20px" }}
                ></Column>
                <Column
                  field="exp_date"
                  body={renderDueDate}
                  header="Date"
                  sortable
                  style={{ paddingRight: "20px" }}
                ></Column>
                <Column
                  field="exp_is_billable"
                  body={renderStatus}
                  header="Billable"
                  sortable
                  style={{ paddingRight: "20px" }}
                ></Column>
                <Column
                  field="amount"
                  body={renderAmount}
                  className="amount-expense-recent"
                  header="Amount"
                  sortable
                  style={{ paddingRight: "20px" }}
                ></Column>
              </DataTable>
            </div>
          </motion.div>
        </div>
      </Modal>
    </div>
  );
};

export default ExpenseHistory;
